export default __webpack_public_path__ + "assets/images/b55e50b045518fd7948cfa180c25c5ed.png";